import { columnsheadId } from '../../universal/columnshead';
import WebUniversalNewEx, { WUExtendPropsType, initDataType } from '../../system/WebUniversalNewEx';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import { useRef, useState } from 'react';
import { Button } from 'antd';
import BuyerProudctEdit from './BuyerProudctEdit';

export default function DeptProduct(props: any) {
    const ref = useRef<any>(undefined);
    const { data, closeModal } = props;
    const { buyerId } = data
   
    let apiId = "buyerContact"
    //表头
    const columnsHead = [

        {
            title: '联系人',
            dataIndex: 'contact',
          
        },
        {
            title: '联系电话',
            dataIndex: 'contactPhone',
           
        },
    ];
  
    const handleOk = (e: any) => {
        closeModal(true);
    };
    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '人员',
        apiId,
        showStates: true,
        sendPageData: { buyerId },
        showAdd:false,
        showEdit:false,
        columns,
        pagination: true,
        // EditComponent: BuyerProudctEdit,
        // isExpandable: true,
        // expandableColumns,
        // expandableDataName: 'productSpecs',
    };
   
    return (
        <>
            <AntDraggableModal
                title={'人员'}
                open={true}
                okText='确定'
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={handleOk}
                closable={false}
                maskClosable={false}
                width={800}>
                {/* <Button type="primary" onClick={handleEstimateTransfer}>添加采购商产品</Button> */}
                <WebUniversalNewEx props={extendProps} ref={ref}></WebUniversalNewEx>
            </AntDraggableModal>

        </>

    )
}
